module.exports = __webpack_public_path__ + "img/2.111e4341.png";